// Constantes
const POSITION_STORAGE_PREFIX = 'totem_position_';
const POSITION_METADATA_KEY = 'totem_position_metadata';

/**
 * Salva posição usada pelo totem no localStorage
 * @param {string} slug - Identificador do totem
 * @param {number} position - Número da posição
 * @returns {boolean} true se salvou com sucesso, false caso contrário
 */
export const saveTotemPosition = (slug, position) => {
  const key = `${POSITION_STORAGE_PREFIX}${slug}`;
  const metadata = {
    position: parseInt(position, 10),
    lastUsed: new Date().toISOString(),
    slug: slug
  };
  
  try {
    localStorage.setItem(key, JSON.stringify(metadata));
    
    // Salvar no índice geral
    const allPositions = getAllTotemPositions();
    allPositions[slug] = metadata;
    localStorage.setItem(POSITION_METADATA_KEY, JSON.stringify(allPositions));
    
    return true;
  } catch (error) {
    console.error('❌ Erro ao salvar posição no localStorage:', error);
    return false;
  }
};

/**
 * Recupera posição salva para o totem
 * @param {string} slug - Identificador do totem
 * @returns {number|null} Posição salva ou null
 */
export const getTotemPosition = (slug) => {
  const key = `${POSITION_STORAGE_PREFIX}${slug}`;
  
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    
    const metadata = JSON.parse(stored);
    return metadata.position;
  } catch (error) {
    console.error('❌ Erro ao recuperar posição do localStorage:', error);
    return null;
  }
};

/**
 * Recupera metadados completos da posição
 * @param {string} slug - Identificador do totem
 * @returns {object|null} Metadados ou null
 */
export const getTotemPositionMetadata = (slug) => {
  const key = `${POSITION_STORAGE_PREFIX}${slug}`;
  
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    
    return JSON.parse(stored);
  } catch (error) {
    console.error('❌ Erro ao recuperar metadados:', error);
    return null;
  }
};

/**
 * Verifica se existe posição salva
 * @param {string} slug - Identificador do totem
 * @returns {boolean}
 */
export const hasTotemPosition = (slug) => {
  return getTotemPosition(slug) !== null;
};

/**
 * Remove posição salva (uso em casos excepcionais)
 * @param {string} slug - Identificador do totem
 * @returns {boolean} true se removeu com sucesso, false caso contrário
 */
export const clearTotemPosition = (slug) => {
  const key = `${POSITION_STORAGE_PREFIX}${slug}`;
  
  try {
    localStorage.removeItem(key);
    
    // Remover do índice geral
    const allPositions = getAllTotemPositions();
    delete allPositions[slug];
    localStorage.setItem(POSITION_METADATA_KEY, JSON.stringify(allPositions));
    
    return true;
  } catch (error) {
    console.error('❌ Erro ao remover posição:', error);
    return false;
  }
};

/**
 * Obtém todas as posições salvas
 * @returns {object} Objeto com todas as posições
 */
export const getAllTotemPositions = () => {
  try {
    const stored = localStorage.getItem(POSITION_METADATA_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('❌ Erro ao recuperar índice de posições:', error);
    return {};
  }
};

/**
 * Valida se posição está no formato correto
 * @param {any} position - Posição a validar
 * @returns {boolean}
 */
export const isValidPosition = (position) => {
  const num = parseInt(position, 10);
  return !isNaN(num) && num > 0 && num <= 9999;
};
